import React from 'react';
import _ from 'underscore';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { BiAddToQueue } from 'react-icons/bi';

import { Page } from 'ui/components';
import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';
import useTable from 'ui/components/table';

import tableConfig from './component/table.config';
import Tutorial from './component/tutorial';
import { FormInput } from './component/create';

const initialState = {
  privilege: null,
  isShow: false,
};

const SchemaScreen = () => {
  const SchemaTable = useTable('schema_kurir', tableConfig);
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ privilege, isShow }, setState] = React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.schema.kurir',
    });
    setState((prevState) => ({
      ...prevState,
      privilege: x,
    }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  return (
    <Page className="col-8 bordered">
      <Page.Header
        pretitle="Daftar"
        title={'Skema Kurir'}
        isLoading={StateLoading}
      >
        {(privilege?.action === 'manage' || !Session?.privileges) && (
          <button
            onClick={() =>
              setState((prevState) => ({ ...prevState, isShow: true }))
            }
            className="btn btn-primary px-2"
          >
            <BiAddToQueue color="white" size="14" />
            <span className="d-none d-md-block ms-1">Tambah Skema</span>
          </button>
        )}
      </Page.Header>

      <Page.Navigation>
        <Tutorial />
        <SchemaTable.Tools isLoading={StateLoading} searchable={false} />
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div className="col-md-12 m-0 p-0">
          {StateLoading ? (
            <SkeletonTable headerCount={6} bodyCount={10} />
          ) : (
            <SchemaTable.Render />
          )}
        </div>

        <Modal
          show={isShow}
          onHide={() =>
            setState((prevState) => ({ ...prevState, isShow: false }))
          }
          backdrop="static"
          centered
          size="lg"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Tambah Skema</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormInput
              onClose={() => {
                setState((prevState) => ({ ...prevState, isShow: false }));
              }}
            />
          </Modal.Body>
        </Modal>
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <SchemaTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default SchemaScreen;
